import { useState } from "react";
import { ChevronsUpDown } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Command, CommandEmpty, CommandInput, CommandItem, CommandList } from "@/components/ui/command";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { catColor, catLabel } from "@/lib/lore";

export const EntityPick = ({ entities = [], value, onChange, testid, placeholder = "Pick a note…", search = "Search notes…", empty = "No notes found." }) => {
  const [open, setOpen] = useState(false);
  const cur = entities.find((e) => e.id === value);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button className="flex h-8 w-full min-w-0 items-center justify-between gap-2 rounded border border-[#2D3442] bg-[#0B0D10] px-2 text-left text-xs text-[#F3EBDD] hover:border-[#D97706]/60" data-testid={testid}>
          <span className="truncate">{cur ? cur.name : <span className="text-[#A8A090]">{placeholder}</span>}</span>
          <ChevronsUpDown className="h-3.5 w-3.5 shrink-0 text-[#A8A090]" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-72 p-0" align="start">
        <Command>
          <CommandInput placeholder={search} data-testid={`${testid}-search`} />
          <CommandList className="max-h-72">
            <CommandEmpty>{empty}</CommandEmpty>
            {entities.map((e) => (
              <CommandItem key={e.id} value={`${e.name} ${e.id}`} onSelect={() => { onChange(e.id); setOpen(false); }} data-testid={`${testid}-option-${e.id}`}>
                <span className="mr-2 h-2 w-2 shrink-0 rounded-full" style={{ background: catColor(e.category) }} />
                <span className="truncate">{e.name}</span>
                <span className="ml-auto pl-2 text-[10px] text-[#A8A090]">{catLabel(e.category)}</span>
              </CommandItem>
            ))}
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
};

export const ListPick = ({ items = [], value, onChange, testid, placeholder }) => (
  <Select value={value || ""} onValueChange={onChange}>
    <SelectTrigger className="h-8 text-xs" data-testid={testid}><SelectValue placeholder={placeholder} /></SelectTrigger>
    <SelectContent>{items.map((i) => <SelectItem key={i.id} value={i.id}>{i.name}</SelectItem>)}</SelectContent>
  </Select>
);

export const Empty = ({ children, testid }) => <p className="px-1 py-6 text-center text-xs text-[#A8A090]" data-testid={testid}>{children}</p>;
